// extracted by mini-css-extract-plugin
module.exports = {"language-checklist":"locale_language-checklist__3AMOD","list":"locale_list__1bXU6"};